(function () {
	const initCarouselSwiper = (scope, navTools) => {
		let carousel = scope.querySelector(`.js-swiper-product-carousel`);

		// Productive #314 - never build a second Swiper on a track that has one.
		// Every product-carousel section renders its own <script src="...section-
		// product-carousel.js"> tag, and the browser runs a classic script once PER
		// TAG, so a homepage with two carousels (New In + Accessories) ran this file
		// twice. Each run bound DOMContentLoaded and initialised EVERY carousel on
		// the page, leaving two live Swiper instances on the same track: both
		// answered a touch, each wrote its own translate to the shared wrapper, and
		// the losing instance's stale state snapped the track back on the next
		// gesture - the mobile stutter and jump-back the client filmed. Measured at
		// 390 on the QA theme: after one swipe the wrapper sat on slide 2 while
		// el.swiper still reported slide 1 / translate 0.
		if (carousel && carousel.swiper) return carousel.swiper;

		let scrollBar = scope.querySelector(`.js-product-carousel-swiper-scrollbar`);

		// Design-truth 7002-115564: no prev/next arrows in the design - the drag
		// scrollbar is the only track navigation.
		let swiperCarousel = new Swiper(carousel, {
			slidesPerView: 1.2,
			spaceBetween: 10,
			slidesOffsetAfter: 20,
			observer: true,
			observeParents: true,
			watchOverflow: true,
			// Productive #314 (round 2): Swiper times a gesture and, past 300ms,
			// only advances when the finger has travelled longSwipesRatio of a
			// slide (default 0.5 - ~150px of a 307px card at 390). A flick on a
			// busy iPhone often registers as a slow gesture, so half a card was
			// the difference between moving on and snapping back. A fifth of a
			// card is enough intent.
			longSwipesRatio: 0.2,
			scrollbar: {
				el: scrollBar,
				draggable: true,
			},
			breakpoints: {
				750: { slidesPerView: 1.2, spaceBetween: 10, slidesOffsetAfter: 0 },
				990: { slidesPerView: 2, spaceBetween: 10, slidesOffsetAfter: 0 },
				1100: { slidesPerView: 3, spaceBetween: 10, slidesOffsetAfter: 0 },
				// Design-truth 7002-115564 (Desktop, Grid=4): 4 cards across + a peek of the next.
				1440: { slidesPerView: 4, spaceBetween: 10, slidesOffsetAfter: 0 },
			},
		});

		// Hide the nav-tools row entirely when the track doesn't overflow (Swiper locks).
		if (swiperCarousel.isLocked) {
			$(navTools).css("display", "none");
		}

		return swiperCarousel;
	};

	const initCarouselTabs = (section, swipersByPanelId) => {
		let $tabs = $(section).find(".product-carousel__tab[role=tab]");

		$tabs.unbind("click").on("click", function () {
			let targetId = $(this).attr("aria-controls");

			$tabs.attr("aria-selected", "false");
			$(this).attr("aria-selected", "true");

			$(section)
				.find(".product-carousel__panel")
				.each(function () {
					$(this).toggleClass("hidden", this.id !== targetId);
				});

			if (swipersByPanelId[targetId]) {
				swipersByPanelId[targetId].updateSize();
				swipersByPanelId[targetId].updateSlides();
				swipersByPanelId[targetId].updateProgress();
				swipersByPanelId[targetId].updateSlidesClasses();
			}

			// Desktop image-clip bug: the per-card image-swap swiper (.product-card-js) inside
			// the panel just revealed was initialised while its ancestor was still `.hidden`
			// (0 width), so it clipped every slide after the first. Its own observer/observeParents
			// (see product-card-slider.js) should already catch the class-removal above, but
			// re-measure explicitly here too so the fix doesn't depend on observer timing.
			let targetPanel = document.getElementById(targetId);
			if (targetPanel) {
				targetPanel.querySelectorAll(".product-card-js").forEach(function (cardSlider) {
					if (cardSlider.swiper) cardSlider.swiper.update();
				});
			}
		});
	};

	const productSlider = () => {
		$(document).ready(function () {
			$(".js-get-section").each(function (index, parent) {
				let parentId = `#${$(parent).attr("id")}`;

				let section = document.querySelector(parentId);

				let panels = section.querySelectorAll(".product-carousel__panel");

				if (panels.length === 0) {
					// Zero-block fallback - no category_tab blocks; single Swiper instance, no tab wiring.
					const zeroBlockSwiper = initCarouselSwiper(
						section,
						section.querySelector(".product-carousel_nav-tools")
					);

					// Panel-1-class bug: a swiper built while the surrounding layout (webfonts,
					// placeholder images) is still settling can measure a stale container width.
					// Re-measure once everything has actually finished loading.
					window.addEventListener("load", () => zeroBlockSwiper.update());
					return;
				}

				let swipersByPanelId = {};

				panels.forEach((panel) => {
					let navTools = panel.querySelector(
						`.product-carousel_nav-tools[data-panel-id]`
					);

					swipersByPanelId[panel.id] = initCarouselSwiper(panel, navTools);
				});

				initCarouselTabs(section, swipersByPanelId);

				// Same settling concern applies to the default-visible first panel (never
				// carries .hidden, so it constructs against a real width up front, but that
				// width can still be wrong before layout has fully settled) - re-measure every
				// panel once the window has finished loading.
				window.addEventListener("load", () => {
					Object.values(swipersByPanelId).forEach((swiperInstance) => swiperInstance.update());
				});
			});
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		productSlider();
		document.addEventListener("shopify:section:load", function () {
			productSlider();
		});
	});
})();
